// extracted by mini-css-extract-plugin
export default {"conferenceList":"youtube_conferenceList__JpXla","conferenceItem":"youtube_conferenceItem__MK+zu"};